import React, { useState } from 'react';
import {toast} from "react-toastify";
import PasswordChecklist from "react-password-checklist"
import {apiCall} from "../redux/utils/api";

const ResetPasswordForm = ({ previousStep, showPassword, emailAddress, setResetForm }) => {
    const [email, setEmail] = useState(emailAddress || '');
    const [password, setPassword] = useState('');
    const [passwordAgain, setPasswordAgain] = useState('');
    const [isPasswordValid, setIsPasswordValid] = useState(false);
    const [doResetPassword, setDoResetPassword] = useState(false);

    const handleSubmit = async (event) => {
        if (!doResetPassword) {
            setDoResetPassword(true);
            event.preventDefault();
            if (showPassword && !isPasswordValid) {
                toast("Passwort entspricht nicht den Anforderungen", {type: "info"});
                return;
            }

            toast("PASSWORD_BEING_RESET", {type: "info"});
            let data = {};
            try {
                data = await apiCall(`${process.env.REACT_APP_API_URL}/authentication-api/resetPassword`, 'POST', {email, password});
            } catch (error) {
                toast(error.message || "Fehler beim Zurücksetzen des Passworts", {type: "info"});
                setDoResetPassword(false);
                return;
            }
            if (!data.error) {
                toast("PASSWORD_RESET_AND_SENT", {type: "success"});
                if (!previousStep) {
                    if (setResetForm) {
                        setResetForm(false);
                    }
                    return;
                }
                previousStep();
            }
            if (data.error) {
                toast(data.error, {type: "info"});
            }
            setDoResetPassword(false);
        }
    };

    const handleBack = () => {
        setResetForm(false);
    }

    return (
        <form onSubmit={handleSubmit}>
            <div className="form-group text-start">
                {!showPassword && (
                <>
                    <label htmlFor="email" className="form-label">E-Mail-Adresse</label>
                    <input
                        type="email"
                        placeholder="Email"
                        className="form-control"
                        id="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                    />
                </>
                )}
                {showPassword && (
                    <>
                        <label htmlFor="password" className="form-label">Passwort</label>
                        <input
                            type="password"
                            className="form-control my-2"
                            value={password}
                            onChange={e => setPassword(e.target.value)}
                        />
                        <label htmlFor="passwordAgain" className="form-label">Passwort wiederholen</label>
                        <input
                            type="password"
                            className="form-control my-2"
                            value={passwordAgain}
                            onChange={e => setPasswordAgain(e.target.value)}
                        />
                        <PasswordChecklist
                            rules={["minLength", "specialChar", "number", "capital", "match"]}
                            minLength={5}
                            value={password}
                            valueAgain={passwordAgain}
                            onChange={(isValid) => setIsPasswordValid(isValid)}
                        />
                    </>
                )}
            </div>
            <div className="mb-2 py-2 text-end">
                {previousStep && (
                    <button type="button" className="btn btn-link" onClick={() => previousStep()}>Zurück</button>
                )}
                {!previousStep && (
                    <button type="button" className="btn btn-secondary" onClick={() => handleBack()}>Zurück</button>
                )}
                <button type="submit" className="btn btn-primary">Reset</button>
            </div>
        </form>
    );
};

export default ResetPasswordForm;
